export default __webpack_public_path__ + "images/GZ.5cec018.png";